import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import humanTime from 'flarum/common/utils/humanTime';
const TAG = 'finance-business';
const MIN_REPLIES = 2; // only discussions people are actually talking in

/**
 * Voucha discussions next to the figures, with at least 2 replies: the latest active in Finance & Business,
 * or (with attrs.query) those whose title names a company. A Join button for Finance & Business underneath; visitors are asked to sign up first.
 */
export default class MarketDiscussions extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.items = null;
    this.load();
  }
  load() {
    const filter = this.attrs.query ? {
      q: this.attrs.query
    } : {
      tag: TAG
    };
    // fetch more than needed, then keep discussions with at least 2 replies (and, on a company page, whose title names it)
    const params = {
      filter,
      include: 'user,tags',
      page: {
        limit: 50
      }
    };
    if (!this.attrs.query) params.sort = '-lastPostedAt';
    app.store.find('discussions', params).then(list => {
      this.items = Array.from(list || []).filter(d => (d.commentCount() || 0) - 1 >= MIN_REPLIES).filter(d => !this.attrs.match || this.attrs.match(d.title())).slice(0, this.attrs.limit || 5);
    }).catch(() => this.items = []).then(() => m.redraw());
  }
  view() {
    const tag = app.store.getBy('tags', 'slug', TAG);
    const items = this.items;
    return m('section.VouchaMarkets-section.VouchaMk-talk', [m('h2', this.attrs.title || 'Talk about the market'), items === null ? m('p.VouchaMarkets-note', 'Loading discussions…') : items.length ? m('ul.VouchaMk-talkList', items.map(d => m('li', [m('a.VouchaMk-talkTitle', {
      href: app.route.discussion(d)
    }, d.title()), m('span.VouchaMk-talkMeta', [d.user() ? d.user().displayName() + ' · ' : '', Math.max(0, (d.commentCount() || 1) - 1) + ' repl' + ((d.commentCount() || 1) - 1 === 1 ? 'y' : 'ies'), ' · ', humanTime(d.lastPostedAt() || d.createdAt())])]))) : m('p.VouchaMarkets-note', this.attrs.empty || 'No discussions yet.'), tag ? m('.VouchaMk-talkActions', [this.joinButton(tag), m('a.Button', {
      href: app.route('tag', {
        tags: tag.slug()
      })
    }, 'See all in ' + tag.name())]) : null]);
  }
  joinButton(tag) {
    const user = app.session.user;
    const sub = user && typeof tag.subscription === 'function' ? tag.subscription() : null;
    const joined = sub && sub !== 'not_follow';
    if (joined) return null; // already a member: just the link to the tag
    return m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.saving,
      onclick: () => {
        if (!user) {
          try {
            const shown = app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'));
            if (shown && shown.catch) shown.catch(() => {});
          } catch (e) {}
          return;
        }
        if (typeof tag.subscription !== 'function') {
          window.location.href = app.route('tag', {
            tags: tag.slug()
          });
          return;
        }
        this.saving = true;
        tag.save({
          subscription: 'follow'
        }).catch(() => {}).then(() => {
          this.saving = false;
          m.redraw();
        });
      }
    }, 'Join ' + tag.name());
  }
}
flarum.reg.add('voucha-markets', 'forum/components/MarketDiscussions', MarketDiscussions);